import request from "_private/utils/request";

/**
 * 获取列表数据
 * @param {*} data
 */
export function FetchFindByPage(data) {
    return request({
        url: "/emergencyVehicle/findByPage",
        method: "post",
        headers: {type: "json"},
        data
    });
}
/**
 * 初始化门店冷柜树
 */
export function FetchVehicleTree() {
    return request({
        url: "/emergencyVehicle/getEmergencyVehicleInfoTree",
        method: "post",
    });
}

/**
 * 获取应急企业下拉
 * @constructor
 */
export function FetchEmergencyComparyName() {
    return request({
        url: "/emergencyVehicle/getEmergencyComparyName",
        method: "post",
    });
}